import { render, staticRenderFns } from "./FiltersDialogCustomsDashboard.vue?vue&type=template&id=e8d7a8f8&"
import script from "./FiltersDialogCustomsDashboard.vue?vue&type=script&lang=js&"
export * from "./FiltersDialogCustomsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./FiltersDialogCustomsDashboard.vue?vue&type=style&index=0&id=e8d7a8f8&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8d7a8f8')) {
      api.createRecord('e8d7a8f8', component.options)
    } else {
      api.reload('e8d7a8f8', component.options)
    }
    module.hot.accept("./FiltersDialogCustomsDashboard.vue?vue&type=template&id=e8d7a8f8&", function () {
      api.rerender('e8d7a8f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/elements/invoices/FiltersDialogCustomsDashboard.vue"
export default component.exports